/* eslint-disable jsx-a11y/alt-text */
import React,{useState}  from 'react';
import  '../styles/style.css';
import { Grid ,GridToolbar, GridColumn as Column } from '@progress/kendo-react-grid';
import { Button } from "@progress/kendo-react-buttons";
import { ExcelExport} from "@progress/kendo-react-excel-export";
import { orderBy ,process} from "@progress/kendo-data-query";
import {setGroupIds,  setExpandedState,} from "@progress/kendo-react-data-tools";
import excelIcon from '../imagen/Excel.png'; // Tell webpack this JS file uses this image
//import pdfIcon from '../imagen/PDF.png';
import '@progress/kendo-react-intl'; // Importar el archivo de cultura español
function gridreportes({ dato }) {
//const columns =Object.keys(dato);
const columns = dato && dato.length > 0 ? Object.keys(dato[0]) : [0];
const processWithGroups = (data, dataState) => {
  const newDataState = process(data, dataState);
  setGroupIds({
    data: newDataState.data,
    group: dataState.group,
  });
  return newDataState;
};

const initialDataState = {
  take: 100,
  skip: 0,
  group: [
  ],
};
 
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [dataState, setDataState] = React.useState(initialDataState);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [resultState, setResultState] = React.useState(
    processWithGroups(dato, initialDataState)
  );
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [collapsedState, setCollapsedState] = React.useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const onDataStateChange = React.useCallback((event) => {
    const newDataState = processWithGroups(dato, event.dataState);
    setDataState(event.dataState);
    setResultState(newDataState);
  }, [dato]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const onExpandChange = React.useCallback(
    (event) => {
      const item = event.dataItem;
      if (item.groupId) {
        const collapsedIds = !event.value
          ? [...collapsedState, item.groupId]
          : collapsedState.filter((groupId) => groupId !== item.groupId);
        setCollapsedState(collapsedIds);
      }
    },
    [collapsedState]
  );
  const newData = setExpandedState({
    data: resultState.data,
    collapsedIds: collapsedState,
  });
  const initialSort = [
  {
    field: "",
    dir: "desc",
  },
];
  // eslint-disable-next-line no-undef, react-hooks/rules-of-hooks
  const [sort, setSort] = useState(initialSort);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };

  return (
    <div >
    
    <GridToolbar>
                 <div>
                   <Button  image={excelIcon}
                     onClick={excelExport}
                     title="Export PDF"
                     type="button" >
                      <img src={excelIcon} />
                   </Button>
                   
                 </div>
               </GridToolbar>
               <ExcelExport   data={orderBy(newData, sort)}  ref={_export}>
                   <Grid
                       resizable={true}
                       style={{height: "400px",   }}
                       pageable={{ pageSizes: true, }}
                       data={orderBy(newData, sort)}
                       total={resultState.total}
                       onDataStateChange={onDataStateChange}
                       {...dataState}
                       onExpandChange={onExpandChange}
                       expandField="expanded"
                      //  scrollable="virtual"
                       scrollable={true}
                       groupable={true}
                       size={"100px"}
                       filterable={true}
                       sort={sort}
                      // fixedScroll={true}
                      // rowHeight={15}
                       onSortChange={(e) => { setSort(e.sort);  }}  
                      >
                        </Grid>  
                      {columns.map((column, index) => {
                              return (
                                <Column 
                                  field={column}
                                  title={column}
                                  key={index}
                                 // width={setPercentage(50)}
                                  //minResizableWidth={2}
                                  //locked={false}
                                  width="250px"
                                  minResizableWidth={30}
                                  filterable={true}
                                />
                              );
                            })}
              </ExcelExport>
    </div>
  );
} 
export default gridreportes